import { type FC, type ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import { type LoginStep } from 'components/Login/LoginForm/types';
import { type InvitationInfo } from 'types/invitation';

import { ESCDA2025 } from './components/ESCDA2025';
import { FeaturesPresentation } from './components/FeaturesPresentation';
import LegalBeneficiaryPresentation from './components/LegalBeneficiaryPresentation';
import * as S from './styles';
import { isAccountant, isAdmin, isEmployee, isLegalBeneficiary } from './utils';

interface AuthentificationLayoutProps {
  children: ReactNode;
  currentStep?: LoginStep;
  invitationInfo: Pick<InvitationInfo, 'role'> | null;
}

const AuthentificationLayout: FC<AuthentificationLayoutProps> = ({
  children,
  invitationInfo: invitation,
}) => {
  const { featureFlags } = useFeatureFlagsSwitcher();

  const shouldDisplayESCDA2025Visuals =
    featureFlags.enableESCDA2025Visuals &&
    !isEmployee(invitation?.role) &&
    !isAccountant(invitation?.role);

  const renderRightContent = () => {
    if (isLegalBeneficiary(invitation?.role) || isAdmin(invitation?.role)) {
      return <LegalBeneficiaryPresentation flexGrow={1} marginLeft="auto" />;
    }

    if (shouldDisplayESCDA2025Visuals) {
      return <ESCDA2025 />;
    }

    return <FeaturesPresentation invitation={invitation} />;
  };

  return (
    <Flex height="100vh" textAlign="center" width="100vw">
      <S.LeftContent>{children}</S.LeftContent>

      {renderRightContent()}
    </Flex>
  );
};

export default AuthentificationLayout;
